import React from 'react';
import { DeleteConfirmModal } from '../../../components/generic/DeleteConfirmModal';
import { createModal } from '../../../components/generic/Modal';
import { useDeleteFormMutation } from '../../../graphql/hooks/useDeleteFormMutation';
import { useAppContext } from '../../../hooks/useAppContext';

interface Props {
  formId: string;
  formName: string;
}

export const FormDeleteModal = createModal<Props>((props) => {
  const { formId, formName, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();

  const mutation = useDeleteFormMutation();

  const onDelete = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        formId,
      })
      .then(async () => {
        successToast('Form deleted successfully');
      })
      .catch((err) => {
        errorToast(`Error deleting form: ${err.message}`);
      });
  }, [mutation, organization.id, formId, successToast, errorToast]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this form?'
      confirmation={{ level: 'Level2', confirm: formName }}
      onDelete={onDelete}
      isLoading={mutation.isLoading}
    />
  );
});
